"use client"

import React from 'react';
import { Handle, Position } from 'reactflow';
import './Node.css';

const PlaceholderNode = ({ data }) => {
  return (
    <div
      style={{
        width: '100px',
        height: '50px',
        border: '2px dashed #b1b1b7',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f4f8',
        opacity: 0.8,
        fontSize: '12px',
        color: '#64748b',
        padding: '0 8px',
        textAlign: 'center',
      }}
    >
      {data.label}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          width: '8px',
          height: '8px',
          background: 'transparent',
          border: '2px solid #b1b1b7',
        }}
      />
    </div>
  );
};

export default PlaceholderNode;
